import { ApiError, apiFetch, readJson, type GetToken } from '@/lib/api/client'
import type {
  CreateListingInput,
  ListingFilters,
  OwnerListing,
  PublicListing,
} from '@/lib/types/listing'
import type { CreatedReport } from '@/lib/types/report'

export function listListings(
  filters: ListingFilters = {},
): Promise<PublicListing[]> {
  return apiFetch('/api/listings', {
    query: {
      q: filters.q,
      brand: filters.brand,
      category: filters.category,
      type: filters.type,
    },
  }).then((response) => readJson<PublicListing[]>(response))
}

export function getListing(id: string): Promise<PublicListing> {
  return apiFetch(`/api/listings/${id}`).then((response) =>
    readJson<PublicListing>(response),
  )
}

export function createListing(
  input: CreateListingInput,
  getToken: GetToken,
): Promise<OwnerListing> {
  return apiFetch('/api/listings', {
    method: 'POST',
    body: input,
    getToken,
  }).then((response) => readJson<OwnerListing>(response))
}

/** Records the claim and returns the destination URL for the client to open. */
export async function claimListing(
  id: string,
  getToken: GetToken,
): Promise<string> {
  const response = await apiFetch(`/api/listings/${id}/claim`, {
    method: 'POST',
    getToken,
  })
  const data = await readJson<{ destinationUrl: string }>(response)
  if (!data.destinationUrl) {
    throw new ApiError(response.status, 'Claim did not return a destination')
  }
  return data.destinationUrl
}

export function reportListing(
  id: string,
  reason: string,
  getToken: GetToken,
): Promise<CreatedReport> {
  return apiFetch(`/api/listings/${id}/report`, {
    method: 'POST',
    body: { reason },
    getToken,
  }).then((response) => readJson<CreatedReport>(response))
}
